import { Check } from "../check";
import { Store } from "../store";
import { Customer } from "./Customer.entity";
import { CustomerVenueVisit } from "./CustomerVenueVisit.entity";

export class CustomerVenue {
	customerKey: string;
	venueKey: number;
	firstVisitDateTime: Date;
	lastVisitDateTime: Date;
	visitRevenue: number;
	visitCount: number;
	track: boolean;
	tags: string[];

	Customer: Customer;

	CustomerVenueVisit: CustomerVenueVisit[];

	Venue: Store;

	Checks: Check[];

	venueName: string;
	venueStreet: string;
	venueStreet2: string;
	venueCity: string;
	venueState: string;
	venuePostalCode: string;
	venuePhone: string;
	venueEmail: string;
	venueOnlineOrderUrl: string;

	visits: CustomerVenueVisit[];

	public constructor(init?: Partial<CustomerVenue>) {
		Object.assign(this, init);
	}
}
